import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const StyledDiv = styled.div`
  height: 200px;
`;

export const SgNewsItemSkeleton: FC = () => (
  <StyledDiv className="card col-12">
    <div className="row">
      <div className="card-header col col-md-4 bg-lvl3 my-2"></div>
      <div className="card-body col col-md-8 px-0 pb-4 ps-md-4 my-2">
        <h2 className="text-primary">
          <Skeleton width="25rem" />
        </h2>
        <p className="text-large my-2">
          <Skeleton count={4} />
        </p>
        <span className="text-secondary">
          <Skeleton width="15rem" />
        </span>
      </div>
    </div>
  </StyledDiv>
);
